import ClassChallenge from './ClassChallenge.jsx'
import ClassMeeting from './ClassMeeting.jsx'
import ServiceLearningProject from './ServiceLearningProject.jsx'

export default {
  ClassChallenge,
  ClassMeeting,
  ServiceLearningProject,
}
